import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_YK_API_BASE || 'http://localhost:5000/ykrestapi';

/**
 * Sends an approved WhatsApp payment confirmation template message.
 * The Meta access token is kept server-side — this call only sends payment data
 * to our own backend, which then contacts Meta's Cloud API.
 *
 * @param {Object} payload
 * @param {string}   payload.customerName
 * @param {string[]} payload.phoneNumbers      - E.164 format numbers, e.g. ["15551234567"]
 * @param {string}   payload.paymentId         - Transaction / payment ID
 * @param {string}   payload.amount            - Numeric string, e.g. "50.00"
 * @param {string}   [payload.currency]        - Defaults to "USD"
 * @param {string}   [payload.orderId]         - Order or class ID
 * @param {string}   payload.serviceName       - "Class" | "Tiffin" | "Camp"
 *
 * Class-specific:
 * @param {string}   [payload.className]       - e.g. "Yoga Beginners"
 * @param {string}   [payload.classDate]       - e.g. "Jan 1 - Mar 31, 2026"
 * @param {number}   [payload.studentCount]    - Number of enrolled students
 *
 * Tiffin-specific:
 * @param {string}   [payload.orderItems]      - e.g. "Rice x2, Dal x1, Sabji x1"
 * @param {string}   [payload.pickupTime]      - e.g. "12:00 PM"
 *
 * @returns {Promise<Object>} WhatsAppPaymentResponse { success, results[] }
 */
const sendPaymentConfirmation = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/WhatsApp/SendPaymentConfirmation`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
};

const whatsAppService = {
  sendPaymentConfirmation,
};

export default whatsAppService;
